<template>
    <AprCouponCodeSection :blok="blok" />
</template>

<script setup lang="ts">
import AprCouponCodeSection from '~/components/sections/AprCouponCodeSection.vue';
// import type { IAprCouponCodeSection } from '~/../types/AprCouponCodeSection';

// defineProps<{ blok: IAprCouponCodeSection }>();
defineProps<{ blok: any }>();
</script>

<style lang="postcss" scoped></style>
